<template>
    <div>
        <AppButton element="button" type="button" @click="open = !open" v-show="!open">
            {{ message }}
        </AppButton>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div v-show="open">
                <slot name="content" />
            </div>
        </transition>
    </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
    },
    data() {
        return {
            message: this.$t('messages.see_more'),
            open: false,
        };
    },
};
</script>
